/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiServer } from '../../asyncapi/models/AaiServer';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete all servers from an aai20document.
 * 
 * @author c.desc2@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllServersCommand_Aai20 extends AbstractCommand {
    public _oldServers : any;

    constructor() {
        super();
        if(this._oldServers===undefined) this._oldServers = null;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllServersCommand_Aai20] Executing.");
        this._oldServers = <any>({});
        let parent : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(parent.servers)) {
            return;
        }
        let servers : any = parent.servers;
        if(!this.isNullOrUndefined(servers)) {
            /* keySet */Object.keys(servers).forEach(((servers) => {
                return (serverName) => {
                    /* put */(this._oldServers[serverName] = Library.writeNode(/* get */((m,k) => m[k]===undefined?null:m[k])(servers, serverName)));
                }
            })(servers));
        }
        NodeCompat.setProperty(parent, Constants.PROP_SERVERS, <any>({}));
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllServersCommand_Aai20] Reverting.");
        if(/* size */Object.keys(this._oldServers).length === 0) {
            return;
        }
        let parent : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(parent.servers)) {
            return;
        }
        let servers : any = parent.servers;
        if(this.isNullOrUndefined(servers)) {
            servers = <any>({});
            NodeCompat.setProperty(parent, Constants.PROP_SERVERS, servers);
        }
        /* keySet */Object.keys(this._oldServers).forEach(((parent) => {
            return (serverName) => {
                let server : AaiServer = parent.createServer$java_lang_String(serverName);
                Library.readNode(/* get */((m,k) => m[k]===undefined?null:m[k])(this._oldServers, serverName), server);
                /* put */(parent.servers[serverName] = server);
            }
        })(parent));
    }
}
DeleteAllServersCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllServersCommand_Aai20";
DeleteAllServersCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




